export default __webpack_public_path__ + "circle50368e.png";